// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__card-head-container__JU8xb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__card-head-container__JU8xb .index-module__section1__FbeJ2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__card-head-container__JU8xb .index-module__section2__UNvWm {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
}
.index-module__card-head-container__JU8xb .index-module__section2__UNvWm .index-module__searchBox__fmFXv {
  min-width: 100%;
}
.index-module__action-icon__kKaYs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.index-module__actionAllDevice__kriqA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5%;
}
.index-module__modal__description__MP3ie {
  font-weight: bolder;
  font-size: 18px;
  color: var(--app-primary-color) !important;
  cursor: pointer;
}
.index-module__user-list__table--action-col-icon__iaxyE {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  margin: 0 5%;
}
.index-module__view_user_text_color__yI98h {
  color: var(--app-primary-color) !important;
  font-weight: 600;
  cursor: pointer;
}
.index-module__table-text-wrap__Rzux4 {
  word-wrap: "break-word" !important;
  word-break: "break-word" !important;
}
.index-module__user-icon__b4LpI {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}
.index-module__user-icon-container__msjio {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/MobileUser/MobileUserList/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.card-head-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.card-head-container .section1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.card-head-container .section2 {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2rem;\n}\n.card-head-container .section2 .searchBox {\n  min-width: 100%;\n}\n.action-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n.actionAllDevice {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 5%;\n}\n.modal__description {\n  font-weight: bolder;\n  font-size: 18px;\n  color: var(--app-primary-color) !important;\n  cursor: pointer;\n}\n.user-list__table--action-col-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 19px;\n  margin: 0 5%;\n}\n.view_user_text_color {\n  color: var(--app-primary-color) !important;\n  font-weight: 600;\n  cursor: pointer;\n}\n.table-text-wrap {\n  word-wrap: \"break-word\" !important;\n  word-break: \"break-word\" !important;\n}\n.user-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  font-weight: bold;\n}\n.user-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-head-container": `index-module__card-head-container__JU8xb`,
	"section1": `index-module__section1__FbeJ2`,
	"section2": `index-module__section2__UNvWm`,
	"searchBox": `index-module__searchBox__fmFXv`,
	"action-icon": `index-module__action-icon__kKaYs`,
	"actionAllDevice": `index-module__actionAllDevice__kriqA`,
	"modal__description": `index-module__modal__description__MP3ie`,
	"user-list__table--action-col-icon": `index-module__user-list__table--action-col-icon__iaxyE`,
	"view_user_text_color": `index-module__view_user_text_color__yI98h`,
	"table-text-wrap": `index-module__table-text-wrap__Rzux4`,
	"user-icon": `index-module__user-icon__b4LpI`,
	"user-icon-container": `index-module__user-icon-container__msjio`
};
export default ___CSS_LOADER_EXPORT___;
